<template>
  <div class="policy" v-loading="loading">
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.protocolType == 1">游学</span>
            <span v-if="scope.row.protocolType == 2">问卷</span>
          </template>
        </el-table-column>
        <el-table-column prop="protocolName" label="名称"></el-table-column>
        <el-table-column prop="updatedTime" label="更新时间"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="160">
          <template slot-scope="scope">
            <el-button v-per="['agreement:list:look']" class="btn" type="primary" plain @click="gopath(1, scope.row)">查看</el-button>
            <el-button v-per="['agreement:list:edit']" class="btn" type="" plain @click="gopath(2, scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.protocolInfoselectProtocolInfoList)
        .then(res => {
          this.tableData = res.result
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    gopath(e, row) {
      let id = row?.id
      this.$router.push({ name: "agreementitem", query: { type: e, id } })
    },
  },
}
</script>

<style scoped lang="scss"></style>
